import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { commonUtils } from '../../common/index.js';

import { BaseTransform } from './BaseTransform.js';

export class SortTransform extends BaseTransform {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions): void {
		let response: any = queryResponse;
		const { sortTransformOptions } = this.options;

		if (queryResponse) {
			const { direction, key } = sortTransformOptions;

			let filteredList = [];
			const nullList = [];

			// Filters the response for any null or undefined values
			for (const item of response) {
				const value = key ? commonUtils.getValueFromDotNotation(key, item, null) : item;

				if (value != null && value !== undefined) {
					filteredList.push(item);
				} else {
					nullList.push(item);
				}
			}

			// Sorts the filteredList
			filteredList = filteredList.sort((a, b) => {
				if (key) {
					a = commonUtils.getValueFromDotNotation(key, a, null);
					b = commonUtils.getValueFromDotNotation(key, b, null);
				}

				let result;

				if (typeof a === 'number' && typeof b === 'number') {
					result = a > b ? 1 : -1;
				} else {
					result = a.toString().localeCompare(b.toString());
				}

				if (direction === 'DESC') {
					result = result * -1;
				}
				return result;
			});

			// Concat's the 2 lists, so the null or undefined values are at the end
			response = filteredList.concat(nullList);
		}
		return response;
	}
}
